/**
 * Seuil de vérification bon cadeau (logique pure, sans DOM).
 *
 * Particularité story 5.3 : les codes TEST-* admin sont plus courts que les bons
 * Payrexx (longueur ≈ codeLength + 8 + codeSplit). Dès qu’il y a un caractère
 * après le préfixe test, on déclenche /verify-gift-voucher-code.
 *
 * @param {string} rawValue
 * @param {number|null} minVerifyLength
 * @param {string|null} testPrefix
 * @returns {boolean}
 */
function shouldTriggerGiftVoucherVerifyWithConfig(rawValue, minVerifyLength, testPrefix) {
    if (minVerifyLength === null || minVerifyLength === undefined) {
        return false;
    }
    if (!Number.isFinite(minVerifyLength) || minVerifyLength <= 0) {
        return false;
    }

    const value = String(rawValue || '').trim();
    if (value === '') {
        return false;
    }

    const prefix = testPrefix ? String(testPrefix).trim().toUpperCase() : '';
    if (prefix !== '' && value.toUpperCase().startsWith(prefix) && value.length > prefix.length) {
        return true;
    }

    return value.length >= minVerifyLength;
}

module.exports = { shouldTriggerGiftVoucherVerifyWithConfig };
module.exports.default = { shouldTriggerGiftVoucherVerifyWithConfig };
